// test96
(96 && 0);
